function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import shallow from 'zustand/shallow';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import useStore from './../store';
import { getGeoFeatureLabel, getRegionNameFromFeature } from './../utils';
import DemographicsPanel from './DemographicsPanel';
import IndicatorSummary from '../Indicators/IndicatorSummary';
import useCategorizedIndicators from '../App/hooks/useCategorizedIndicators';
import useActiveMetric from '../App/hooks/useActiveMetric';
import styled from 'styled-components';
import PanelHeader from '../../../core/Panel/PanelHeader';
import Panel from '../../../core/Panel/Panel';
import PanelBody from '../../../core/Panel/PanelBody';
import { Button } from 'reactstrap';
import useFeedbackPanel from '../Feedback/useFeedbackPanel';
import { FeedbackIcon } from '../../../core/Icons';

var PanelLocationView = function PanelLocationView(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      props = _objectWithoutPropertiesLoose(_ref, ["open", "onClose"]); // Generic store value setter.


  var _useStore = useStore(function (state) {
    return {
      activeFeature: state.activeFeature,
      activeLayers: state.activeLayers,
      trendData: state.trendData
    };
  }, shallow),
      activeFeature = _useStore.activeFeature,
      activeLayers = _useStore.activeLayers,
      trendData = _useStore.trendData;

  var _useActiveMetric = useActiveMetric(),
      activeMetric = _useActiveMetric[0],
      setActiveMetric = _useActiveMetric[1];

  var categories = useCategorizedIndicators();
  var region = getRegionNameFromFeature(activeFeature); // component is ready to render if there is an active feature

  var isReady = Boolean(activeFeature); // get trend data for active feature

  var trends = trendData.filter(function (el) {
    var _activeFeature$proper;

    return Number(el.GEOID) === Number(activeFeature === null || activeFeature === void 0 ? void 0 : (_activeFeature$proper = activeFeature.properties) === null || _activeFeature$proper === void 0 ? void 0 : _activeFeature$proper.GEOID);
  }); // Stores the index of the selected location's layer
  // for fetching min, max, and mean from indicator arrays.

  var activeLayerIndex = activeLayers.indexOf(1);

  var handleActivateIndicator = function handleActivateIndicator(indicator) {
    setActiveMetric(indicator.id);
  };

  var _useFeedbackPanel = useFeedbackPanel(),
      showFeedbackForRegion = _useFeedbackPanel.showFeedbackForRegion;

  var handleShowFeedback = function handleShowFeedback() {
    return showFeedbackForRegion(activeFeature);
  };

  return /*#__PURE__*/React.createElement(Panel, _extends({
    className: "map-panel-slideout-location",
    open: open && isReady
  }, props), /*#__PURE__*/React.createElement(PanelHeader, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement("h2", {
    className: "gotham18"
  }, getGeoFeatureLabel(activeFeature)), /*#__PURE__*/React.createElement(Button, {
    onClick: handleShowFeedback,
    color: "outlined knockout12"
  }, /*#__PURE__*/React.createElement(FeedbackIcon, {
    className: "mx-3 d-block"
  }), /*#__PURE__*/React.createElement("span", null, i18n.translate("FEEDBACK")))), activeFeature && /*#__PURE__*/React.createElement(PanelBody, null, /*#__PURE__*/React.createElement(DemographicsPanel, {
    className: "p-5",
    activeFeature: activeFeature
  }), categories.map(function (_ref2) {
    var name = _ref2.name,
        indicators = _ref2.indicators;
    return /*#__PURE__*/React.createElement("div", {
      className: "px-5 pt-5 pb-0 border-top",
      key: name
    }, /*#__PURE__*/React.createElement("h3", {
      className: "gotham16 mb-5"
    }, name), indicators.map(function (indicator) {
      return /*#__PURE__*/React.createElement(IndicatorSummary, {
        key: indicator.id,
        indicator: indicator,
        data: activeFeature.properties,
        trends: trends,
        active: activeMetric === indicator.id,
        onActivate: handleActivateIndicator,
        activeLayerIndex: activeLayerIndex,
        region: region
      });
    }));
  })));
};

export default PanelLocationView;